import {
    BoxShadowLarge,
    ColorNeutralWhite,
    ColorNordicGrey1,
    ColorNordicGrey3,
    ColorSystemAttention2,
    ColorSystemNegative1,
    ColorSystemPositive1,
    Spacing12,
    Spacing16,
    Spacing4
} from 'autogen/design-tokens/tokens';
import { ButtonWithIcon } from 'components/Button';
import Icon from 'components/Icon';
import { cssTransition, ToastContainer } from 'react-toastify';
import styled from 'styled-components';
import { breakpoint, sizes, zIndex } from 'variables';

const StyledToastContainer = styled(ToastContainer)`

    &&& {
        position: fixed;
        z-index: ${zIndex.growl};
    
        &--top-right {
            top: 16px;
            right: 50%;
            transform: translateX(50%);
            width: 100%;
    
            ${breakpoint.up(sizes.sm)} {
                top: 40px;
                right: 16px;
                transform: translateX(0);
                width: auto;
            }
        }
    
        .Toastify__toast {
            display: grid;
            grid-template-columns: auto 1fr auto;
            gap: ${Spacing12};
            box-shadow: ${BoxShadowLarge};
            background-color: ${ColorNeutralWhite};
            padding: ${Spacing12};
            margin: 0 ${Spacing12};
            max-width: 100%;
            border: 1px solid ${ColorNordicGrey3};
    
            
            ${breakpoint.up(sizes.sm)} {
                padding: ${Spacing16};
                margin: unset;
                max-width: 320px;
            }
            
            &:before {
                content: '';
                flex: 0 0 auto;
                width: 4px;
                height: 100%;
                border-radius: 2px;
                background-color: ${ColorNordicGrey1};
            }
    
            &--success {
                &:before {
                    background-color: ${ColorSystemPositive1};
                }
            }
    
            &--warning {
                &:before {
                    background-color: ${ColorSystemAttention2};
                }
            }
    
            &--error {
                &:before {
                    background-color: ${ColorSystemNegative1};
                }
            }
    
            &--info {
                &:before {
                    background-color: ${ColorNordicGrey1};
                }
            }
        }
    
        @keyframes slideInRight {
            from {
                transform: translate3d(100%, 0, 0);
                visibility: visible;
            }
    
            to {
                transform: translate3d(0, 0, 0);
            }
        }
    
        @keyframes slideInDown {
            from {
                transform: translate3d(0%, -110%, 0);
                visibility: visible;
            }
    
            to {
                transform: translate3d(0, 0, 0);
            }
        }
    
        .slideInRight {
            animation: slideInDown 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
    
            ${breakpoint.up(sizes.sm)} {
                animation: slideInRight 0.3s cubic-bezier(0.075, 0.82, 0.165, 1);
            }
        }
    
        @keyframes fadeOut {
            from {
                opacity: 1;
            }
    
            to {
                opacity: 0;
            }
        }
    
        .opacityOut {
            animation: fadeOut 0.2s ease-out both;
        }
    }
`;

const right = cssTransition({
    enter: 'slideInRight',
    exit: 'opacityOut',
    collapseDuration: 250
});

export default function DefaultToastContainer() {
    return (
        <StyledToastContainer
            aria-live="polite"
            aria-atomic="true"
            transition={right}
            hideProgressBar={true}
            autoClose={5000}
            icon={false}
            closeButton={({ closeToast }) => (
                <ButtonWithIcon
                    variant="ghostOnLight"
                    icon={<Icon type="Close" size={16} />}
                    size="sm"
                    onClick={closeToast}
                />
            )}
        />
    );
}
